// extracted by mini-css-extract-plugin
export var closeButton = "_1x-0";